import React, { useEffect } from 'react';
import { useUrlQueryParams } from 'client/hooks/recruitment/RecruitmentList/useUrlQueryParams';
import { useRecruitmentListContext } from 'client/contexts/recruitments/RecruitmentList';
import { HorizontalScrollingCalendar } from 'client/components/recruitments/Calendar/HorizontalScrollingCalendar';
import { useRouter } from 'next/router';

export const Calendar = () => {
  const router = useRouter();
  const {
    searchQueryParams: {
      date: selectedDateText,
      areaIds,
      licenseIds,
      facilityFeatureIds,
      jobBenefitIds,
      sortOptionId,
      maximumDailyWage,
      minimumDailyWage,
      workingHourOptionIds,
      maximumWorkingHours,
      jobTaskIds,
      onlyRecruiting,
    },
    currentDateText,
    dispatch,
  } = useRecruitmentListContext();
  const { urlQueryParams } = useUrlQueryParams({
    date: selectedDateText,
    areaIds,
    licenseIds,
    facilityFeatureIds,
    jobBenefitIds,
    sortOptionId,
    maximumDailyWage,
    minimumDailyWage,
    workingHourOptionIds,
    maximumWorkingHours,
    jobTaskIds,
    onlyRecruiting,
  });

  useEffect(() => {
    router.push(
      {
        query: urlQueryParams,
      },
      {
        // @ts-ignore
        pathname: router.query.name,
        query: urlQueryParams,
      },
      { shallow: true },
    );
  }, [selectedDateText]);

  const dispatchChangeDateFromCalendar = (dateText: string) => {
    dispatch({ type: 'changeDate', payload: { date: dateText } });
  };
  const currentDate = new Date(currentDateText);
  const selectedDate = new Date(selectedDateText);

  return (
    <HorizontalScrollingCalendar
      currentDate={currentDate}
      initialSelectedDate={selectedDate}
      onDateClicked={dispatchChangeDateFromCalendar}
    />
  );
};
